export const processRadixColor = (color: string): string => {
  if (color.startsWith('hsl')) {
    return color.replace(/\.0/g, '').replace(/\s/g, ', ')
  }
  return color
}
